export const BREAD_PAYMENT_SDK = 'breadPaymentSDK'
export const EDS_MAIL_ACCEPT_PAGE = '/credit/accept'
